module.exports = __webpack_public_path__ + "static/media/chat-button.30beafcc.svg";